import React from 'react';
import './HelpTourButton.css';

export interface HelpTourButtonProps {
  onClick: () => void;
  className?: string;
  label?: string;
  title?: string;
  compact?: boolean;
}

const HelpTourButton: React.FC<HelpTourButtonProps> = ({
  onClick,
  className = '',
  label = 'Помощь',
  title = 'Начать экскурсию',
  compact = false,
}) => (
  <button
    type="button"
    className={['help-tour-btn', compact ? 'help-tour-btn--compact' : '', className].filter(Boolean).join(' ')}
    onClick={onClick}
    title={title}
    aria-label={title}
  >
    <i className="fas fa-question-circle" aria-hidden="true" />
    <span className="help-tour-btn__label">{label}</span>
  </button>
);

export default HelpTourButton;
